export const GET_BOOKINGS = 'dashboard/bookings/GET_BOOKINGS';
export const GET_BOOKINGS_SUCCESS = 'dashboard/bookings/GET_BOOKINGS_SUCCESS';
export const GET_BOOKINGS_FAILED = 'dashboard/bookings/GET_BOOKINGS_FAILED';
